"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TopicReplyCountAction = exports.TopicReplyCount = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Reply = _interopRequireDefault(require("@insided/destination/icons/Reply"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _excluded = ["className", "children"];

var TopicReplyCount = function TopicReplyCount(_ref) {
  var replyCount = _ref.replyCount;
  return (0, _preact.h)("span", {
    className: "topic__reply-count"
  }, (0, _preact.h)(_Reply.default, {
    role: "presentation",
    className: (0, _classnames.default)('thread-meta-item__icon', 'icon--auto-width', 'icon--comment'),
    width: 14
  }), (0, _preact.h)(_phrase.default, {
    p: "accessibility_label.current_replies",
    renderAsText: true
  }, function (accessibilityLabel) {
    return (0, _preact.h)("span", {
      className: "thread-meta-item__text",
      "aria-label": accessibilityLabel
    }, replyCount);
  }));
};

exports.TopicReplyCount = TopicReplyCount;

var TopicReplyCountAction = function TopicReplyCountAction(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      anchorProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return (0, _preact.h)(_phrase.default, {
    p: "accessibility_label.reply",
    renderAsText: true
  }, function (accessibilityLabel) {
    return (0, _preact.h)("a", (0, _extends2.default)({
      "aria-label": accessibilityLabel,
      className: (0, _classnames.default)('qa-topic-meta-replies-icon', className)
    }, anchorProps), children);
  });
};

exports.TopicReplyCountAction = TopicReplyCountAction;
var _default = TopicReplyCount;
exports.default = _default;